import React, { useRef } from 'react';

import { block } from 'bem-cn';

import { LANGUAGES } from '../../constants';
import useLocalizedStrings from '../../hooks/useLocalizedStrings';
import { PionType } from '../../type';
import { withStopPropagation } from '../../utils';

import './action-pion.scss';

const b = block('action-pion');

export const TRANSLATIONS = {
  [LANGUAGES.EN]: {
    dismiss: 'Dismiss',
  },
  [LANGUAGES.SV]: {
    dismiss: 'Skippa',
  },
};

type ActionPionPropsType = {
  pion: PionType;
  onPionClick: () => void;
  onAccept: (pion: PionType) => void;
  onDecline: (pion: PionType) => void;
  lang: string;
};

const ActionPion = ({
  pion,
  onPionClick = () => {},
  onAccept = () => {},
  onDecline = () => {},
  lang,
}: ActionPionPropsType) => {
  const redButtonRef = useRef<HTMLDivElement>(null);
  const greenButtonRef = useRef<HTMLDivElement>(null);

  const strings = useLocalizedStrings(TRANSLATIONS, lang);

  return (
    <div className={b()} onClick={onPionClick} data-pionid={pion.get('id')}>
      <div className={b('header')}>
        <div className={b('header-block')}>
          <div className={b('icon')} />
          <h3 className={b('title')} data-testid='action-pion-title'>
            {pion.get('title')}
          </h3>
        </div>
      </div>
      <div className={b('content')}>
        {pion.getIn(['image', 'smallUrl']) && (
          <div className={b('image-wrapper')}>
            <img
              src={pion.getIn(['image', 'smallUrl'])}
              data-testid='action-pion-image'
              alt=''
            />
          </div>
        )}
        <span data-testid='action-pion-text'>{pion.get('content')}</span>
      </div>
      <div className={b('buttons')}>
        <div
          className={b('button', {
            type: 'decline',
            'with-indent': !!pion.get('greenButtonText'),
          })}
          data-testid='action-pion-decline-button'
          onClick={withStopPropagation(() => onDecline(pion))}
          ref={redButtonRef}
        >
          {pion.get('redButtonText') || strings.dismiss}
        </div>
        {pion.get('greenButtonText') && (
          <div
            className={b('button', { type: 'accept' })}
            data-testid='action-pion-accept-button'
            onClick={withStopPropagation(() => onAccept(pion))}
            ref={greenButtonRef}
          >
            {pion.get('greenButtonText')}
          </div>
        )}
      </div>
    </div>
  );
};

export default ActionPion;
